import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AclSecurityAdapter, AclService } from './acl.service';
import { UserService } from './user.service';
import { IUserServerResponse } from '../../../shared/interfaces/user.interface';
import { IRequiredSecurity } from '../../../shared/interfaces/security.interface';
import { FunctionalActions } from '../../../shared/interfaces/security-role.interface';

@Injectable()
export class UserAclService {
  constructor(
    private aclService: AclService,
    private userService: UserService,
  ) {}

  public createCheckAccessForCurrentUser(): Observable<AclSecurityAdapter> {
    return this.userService.userDataChanged$.pipe(
      filter((profile: IUserServerResponse): boolean => profile !== null),
      map((user: IUserServerResponse): AclSecurityAdapter => new AclSecurityAdapter(user, this.aclService)),
    );
  }

  public checkFAAccessForDpWsTenant(actions: FunctionalActions): Observable<boolean> {
    return this.createCheckAccessForCurrentUser().pipe(
      map((aclAdapter: AclSecurityAdapter): boolean =>
        aclAdapter.useDigitalPropertyFromUser().useWorkspaceFromUser().useTenantFromUser().useFunctionalActions(actions).check(),
      ),
    );
  }

  public checkSecurityAccessForDpWsTenant(requiredSecurity: IRequiredSecurity): Observable<boolean> {
    return this.checkFAAccessForDpWsTenant(requiredSecurity.functionalActions);
  }

  public checkFAAccessForTenant(actions: FunctionalActions): Observable<boolean> {
    return this.createCheckAccessForCurrentUser().pipe(
      map((aclAdapter: AclSecurityAdapter): boolean => aclAdapter.useTenantFromUser().useFunctionalActions(actions).check()),
    );
  }

  public checkSecurityAccessForTenant(requiredSecurity: IRequiredSecurity): Observable<boolean> {
    return this.checkFAAccessForTenant(requiredSecurity.functionalActions);
  }
}
